// extracted by mini-css-extract-plugin
export var button = "_ii-0";
export var donut = "_ii-1";
export var donutFill = "_ii-3";
export var donutTrack = "_ii-2";